import { combineReducers } from "redux";
import { localeReducer } from "./localeReducer";
import { authentication } from "./authenticationReducer.js";
import { users } from "./userReducer";
import { alert } from "./alertReducer";
import { products } from "./productReducer";
import { productDescription } from "./productDescription";
import { sellerRegReducer, sellerRegReducer2 } from "./sellerReg";
import { cartItems } from "./cartReducer";
import { checkout } from "./checkoutReducer";
import { productMeta } from "./productData";
import { orders } from "./orderReducer";
import { searchFilter } from "./searchReducer";
import { newArrival } from "./newArrival";
import { sellerDashboard } from "./sellerDashboard";
import { productsListing } from "./productsListing";
import { chat } from "./chat";
import { message } from "./message";
import { sentMessage } from "./sentMessages";
import { marketCampaign } from "./marketCampaign";
import { wishlists } from "./wishlists";
import { rating } from "./rating";
import { trackedOrder } from "./trackedOrder";
import { ratedProduct } from "./ratedProduct";
import { buyerTransactions } from "./buyerTransactions";
import { recentlyViewed } from "./recentlyViewed";
import { inbox } from "./inbox";
import { category } from "./category";
import { categoryDetail } from "./categoryDetail";
import { product } from "./product";
import { jobs } from "./jobs";
import { allUsers } from "./allUsers";
import { nda } from "./nda";
import { ndaPrice } from "./ndaPrice";
import { myNda } from "./myNda";
import { listing, range } from "./getCampaign";
import { advert } from "./getAdvert";
import { currencyConverter } from "./currencyConverter";
import { addSponsorshipProductReducer } from "./addSponsorshipProductReducer";
import { getAllsponsorshipProductReducer } from "./getAllsponsorshipProductReducer";
import { removeDataReducer } from "./removeDataReducer";
import { sellerVerification } from "./sellerVerification";
import { filterOptions } from "./filterOptions";
import { campaignUpdates } from "./campaignUpdates";
import { sponsorshipProductDetail } from "./sponsorshipProductDetailReducer";
import { sellerBoost } from "./sellerBoost";
import { buyerDashboardStats } from "./buyerDashboardStats";
import { sellerDashboardStats } from "./sellerDashboardStats";
import { sellerProductViews } from "./sellerProductViews";
import { sellerPerformance } from "./sellerPerformance";
import { revenueShare } from "./revenueShareReducer";
import { geoLocation } from "./geoLocation";
import { quoteRequests } from "./quoteRequests";
import { coupon } from "./couponReducer";
import { sellerOnboarding } from "./sellerOnboarding";
import { featuredSellers } from "./featuredSellers";
import { productQuestions } from "./productQuestions";
import { sellerVacation } from "./sellerVacation";
import { sellerBundles } from "./sellerBundles";
import { sellerCollections } from "./sellerCollections";
import { wishlistShare } from "./wishlistShare";
import { sharedWishlist } from "./sharedWishlist";
import { savedSearches } from "./savedSearches";
import { priceHistory } from "./priceHistory";
import { waitlist } from "./waitlist";
import { buyerLoyalty } from "./buyerLoyalty";
import { sellerGoals } from "./sellerGoals";
import { sellerDisputes } from "./sellerDisputes";
import { buyerDisputes } from "./buyerDisputes";
import { productCertifications } from "./productCertifications";
import { buyerOnboarding } from "./buyerOnboarding";
import { buyerOnboardingWizard } from "./buyerOnboardingWizard";
import { shippingEstimate } from "./shippingEstimate";
import { subscriptions } from "./subscriptions";
import { buyerReturns } from "./buyerReturns";
import { sellerReturns } from "./sellerReturns";
import { priceAlerts } from "./priceAlerts";
import { landingPage } from "./landingPage";
import { jobPostings } from "./jobPostings";
import { orderTracking } from "./orderTracking";
import { rfq } from "./rfq";
import { sellerAnalytics } from "./sellerAnalytics";
import { upsellPopup } from "./upsellPopup";
import { wishlistFolders } from "./wishlistFolders";


const appReducer = combineReducers({
  locale: localeReducer,
  sellerReg: sellerRegReducer,
  sellerReg2: sellerRegReducer2,
  authentication,
  users,
  alert,
  products,
  productMeta,
  productDescription,
  productsListing,
  cartItems,
  chat,
  buyerTransactions,
  recentlyViewed,
  message,
  sentMessage,
  checkout,
  orders,
  searchFilter,
  newArrival,
  sellerDashboard,
  marketCampaign,
  wishlists,
  rating,
  trackedOrder,
  ratedProduct,
  inbox,
  category,
  categoryDetail,
  product,
  jobs,
  advert,
  allUsers,
  nda,
  ndaPrice,
  myNda,
  listing,
  range,
  currencyConverter,
  addSponsorshipProductReducer,
  getAllsponsorshipProductReducer,
  removeDataReducer,
  sellerVerification,
  filterOptions,
  campaignUpdates,
  sponsorshipProductDetail,
  sellerBoost,
  buyerDashboardStats,
  sellerDashboardStats,
  sellerProductViews,
  sellerPerformance,
  revenueShare,
  geoLocation,
  quoteRequests,
  coupon,
  sellerOnboarding,
  featuredSellers,
  productQuestions,
  sellerVacation,
  sellerBundles,
  sellerCollections,
  wishlistShare,
  sharedWishlist,
  savedSearches,
  priceHistory,
  waitlist,
  buyerLoyalty,
  sellerGoals,
  sellerDisputes,
  buyerDisputes,
  productCertifications,
  buyerOnboarding,
  buyerOnboardingWizard,
  shippingEstimate,
  subscriptions,
  buyerReturns,
  sellerReturns,
  priceAlerts,
  landingPage,
  jobPostings,
  orderTracking,
  rfq,
  sellerAnalytics,
  upsellPopup,
  wishlistFolders,
});

const reducers = (state, action) => {
  if (action.type === "USERS_LOGOUT") {
    return appReducer(undefined, action);
  }

  return appReducer(state, action);
};

export default reducers;
